import {
  configApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { WorkloadClient } from '@internal/workload-api-helper';
import { Grid, Typography } from '@material-ui/core';

import { TextFieldElement } from 'react-hook-form-mui';
import { CustomTooltip, useStyles } from '../CustomTooltip';
import { CatalogFormInputProps } from '../types';
import { validateQuestionDebounced } from '../utils/checks';

export function AlertGroup(props: CatalogFormInputProps) {
  const classes = useStyles();
  const configApi = useApi(configApiRef);
  const oauthApi = useApi(microsoftAuthApiRef);
  const workloadClient = new WorkloadClient(configApi, oauthApi);

  return (
    <Grid container style={{ padding: 5 }} justifyContent="space-between">
      <Grid item xs={11}>
        <TextFieldElement
          disabled={props.disabled}
          name="pfg_alert_group"
          id="pfg_alert_group"
          label="xMatters Group Name"
          variant="outlined"
          className={classes.root}
          validation={{
            required: 'xMatters Group Name is required',
            pattern: {
              value: /^[a-zA-Z0-9.\-_]{1,63}$/,
              message:
                'Alert group must be [a-zA-Z0-9.-_] and fewer than 63 characters.',
            },
            validate: async value => {
              return await validateQuestionDebounced(
                'pfg_alert_group',
                value,
                props.apiValidation,
                workloadClient,
              );
            },
          }}
          fullWidth
          required
        />
      </Grid>
      <Grid container item xs={1} alignItems="center">
        <CustomTooltip
          detail={
            <Typography variant="body1">
              Must be an xMatters group name or <code>no-entry</code>.
            </Typography>
          }
        />
      </Grid>
    </Grid>
  );
}
